import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';

import "./main-view-dialog.scss";
import EvBusMain from "../../utils/evbus";
import MainView from "./main-view";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const MainViewDialog = (props) => {

  const [open, setOpen] = React.useState(false);

  const onClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    const handleOpenEvent = () => {
      setOpen(true);
    };
    const handleCloseEvent = () => {
      setOpen(false);
    }

    EvBusMain.on("OPEN-PROMO-CALENDAR-DIALOG", handleOpenEvent);
    EvBusMain.on("CLOSE-PROMO-CALENDAR-DIALOG", handleCloseEvent);

    return () => {
      EvBusMain.remove("OPEN-PROMO-CALENDAR-DIALOG", handleOpenEvent);
      EvBusMain.remove("CLOSE-PROMO-CALENDAR-DIALOG", handleCloseEvent);
    }
  }, []);

  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      className="promo-calendar-main-view-dialog"
    >
      <MainView fromDialog={true} onClose={onClose} />
    </Dialog>
  );
}

export default MainViewDialog;